module.exports = __webpack_public_path__ + "img/role07.742ae0dc.png";